var render = function render(){var _vm=this,_c=_vm._self._c;return _c('diffInput',{attrs:{"disabled":_vm.disabled,"loading":_vm.load,"type":"select","title":_vm.title ? '' : 'Planlamalar',"label":"filterName","optList":_vm.List,"lightDark":_vm.lightDark,"hideContainer":_vm.hideContainer},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }